<template>
    <div id="forgetPwd">
        <div class="body-bg">
            <div class="login-container">
                <div class="box">
                    <h3 class="title" style="margin-bottom: 0;">
                        <!--忘记密码-->
                    </h3>
                    <h3 class="box1" style="margin-bottom: 0;">
                        <span>我有账号，立即</span><i @click="goLogin">登录</i>
                    </h3>
                </div>
                <el-divider></el-divider>
                <el-form :model="loginForm" :rules="rules" ref="loginForm" @submit.native.prevent label-position="left" label-width="0px" class="demo-ruleForm ">
                    <el-form-item prop="phone" style="display: flex;justify-content: center;">
                        <el-input type="text" v-model="loginForm.phone" auto-complete="off" maxlength="11" placeholder="请输入手机号" prefix-icon="el-icon-mobile-phone"></el-input>
                    </el-form-item>
                    <el-form-item prop="code" style="display: flex;justify-content: center;">
                        <el-input class="aa" type="text" v-model="loginForm.code" maxlength="6" auto-complete="off" placeholder="请输入验证码"></el-input>
                        <el-button class="aabtn" :disabled="count>0" :type="count>0 ? 'info' : 'primary'" @click="sendSms">{{count <= 0 ? '获取验证码' : count + '（s）'}}</el-button>
                    </el-form-item>
                    <el-form-item ref="userPassVal" prop="password1" style="display: flex;justify-content: center;">
                        <el-input type="password" v-model="loginForm.password1" maxlength="16" auto-complete="off" placeholder="请输入新密码" show-password prefix-icon="el-icon-lock"></el-input>
                    </el-form-item>
                    <el-form-item ref="userPassVal" prop="password2" style="display: flex;justify-content: center;">
                        <el-input type="password" v-model="loginForm.password2" maxlength="16" auto-complete="off" placeholder="请输入确认密码" show-password prefix-icon="el-icon-lock"></el-input>
                    </el-form-item>
                    <el-form-item class="submit">
                        <el-button style="width:100%;background:#35B178;color: #fff;border: none;" @click.native.prevent="handleSubmit" native-type="submit" :loading="landing">
                            提交
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>

</template>
<!--suppress BadExpressionStatementJS -->
<script type="text/ecmascript-6">
    import {requestMsgCode,requestResetPassword} from '../api/api';
    export default {
        data() {
            var validatePhone = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入手机号'));
                } else {
                    let myreg=/^[1][3,4,5,6,7,8,9][0-9]{9}$/;
                    if (!myreg.test(value)) {
                        callback(new Error('请输入正确的手机号'));
                    } else {
                        callback();
                    }
                }
            };
            var validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入密码'));
                } else if (value !== this.loginForm.password1) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
            return {
                landing: false,
                loginForm: {
                    password1: '',
                    password2: '',
                    phone:'',
                    code:''
                },
                /*校验规则*/
                rules: {
                    password1: [
                        { required: true, message: '请输入新密码', trigger: 'blur' }
                    ],
                    password2: [
                        { required: true, message: '请输入确认密码', trigger: 'blur' },
                        { min: 8, max: 16, message: '8~16位长度的字母+数字组合', trigger: 'blur' },
                        { validator: validatePass2, trigger: 'blur' }
                    ],
                    phone: [
                        { required: true, message: '请输入手机号', trigger: 'blur' },
                        { min: 1, max: 11, message: '长度在 1 到 11位数字', trigger: 'blur' },
                        { validator: validatePhone, trigger: 'blur' }
                    ],
                    code: [
                        { required: true, message: '请输入验证码', trigger: 'blur' },
                        { min: 1, max: 6, message: '请输入6位短信验证码', trigger: 'blur' }
                    ]
                },
                count:0,
                isPhonePass: false
            };
        },
        methods: {
            sendSms(){
                if(this.loginForm.phone && this.loginForm.phone.length>0){
                    let myreg=/^[1][3,4,5,6,7,8,9][0-9]{9}$/;
                    if (!myreg.test(this.loginForm.phone)) {
                        this.$message({
                            message: "请输入正确的手机号",
                            type: 'error'
                        });
                    } else {
                        let regParams={
                            phone:this.loginForm.phone
                        };
                        requestMsgCode(regParams).then(res => {
                            if(res.code != 200){
                                this.$message({
                                    message: res.msg,
                                    type: 'error'
                                });
                            }else{
                                this.count = 60;
                                if(this.count>0){
                                    setInterval(() => {
                                        this.count--;
                                    }, 1000);
                                }
                            }
                        });
                    }
                }else{
                    this.$message({
                        message: "请输入手机号",
                        type: 'error'
                    });
                }
            },
            goLogin(){
                this.$router.push('/login');
            },
            handleSubmit(ev) {
                let _this = this;
                this.$refs.loginForm.validate((valid) => {
                    if (valid) {
                        this.landing = true;
                        let loginParams = {
                            code: this.loginForm.code,
                            phone: this.loginForm.phone,
                            password: this.loginForm.password1
                        };
                        requestResetPassword(loginParams).then(res => {
                            if(res.code == 200) {
                                this.$message({
                                    message: '找回密码成功，即将前往登录页面！',
                                    type: 'success',
                                    duration:3000,
                                    onClose:function(){
                                        _this.$router.push('/login');
                                    }
                                });
                            } else {
                                this.landing = false;
                                this.$message({
                                    message: res.msg,
                                    type: 'error'
                                });
                                return false;
                            }
                        });
                    } else {
                        return false;
                    }
                });
            }
        },
        beforeMount() {

        }
    }
</script>

<style lang="scss">
    @function rw($px){
        @return $px*100/1920 *1vw;
    }
    @function rh($px){
        @return $px*100/1080 *1vh;
    }
    #forgetPwd{
        height: 100%;
        width: 100%;
        background: #F2F6FC;
        .body-bg{
            width: rw(1920);
            height: rh(1000);
            position: absolute;
        }
        .demo-ruleForm{
            margin-top: rh(20);
        }
        .login-container {
            margin-top: rh(80);
            margin-left: rw(460);
            background:rgba(255,255,255,1);
            border:1px solid rgba(238,238,238,1);
            width:rw(1000) ;
            padding-bottom: rh(80);
            .title {
                margin-left: rw(21);
                font-size:rh(21);
                font-family:MicrosoftYaHei;
                font-weight:400;
                color:rgba(66,66,66,1);
            }
        }
        .ts{
            font-size:rh(14);
            font-family:MicrosoftYaHei;
            font-weight:400;
            color:rgba(156,156,156,1);
            display: block;
        }
        .box{
            display: flex;
            height: rh(60);
            justify-content: space-between;
            position: relative;
            .box1{
                margin-right: rw(21);
                font-size:14px;
                font-family:MicrosoftYaHei;
                font-weight:500;
                display: flex;
                align-items: center;
                span{
                    color:rgba(102,102,102,1);
                }
                i{
                    cursor: pointer;
                    font-style: normal;
                    color: #35B178;
                }
            }
        }
        .el-input{
            width: rw(356);
        }
        .el-select{
            width: rw(356);
        }
        .aa{
            width: rw(212);
        }
        .aabtn{
            padding: 0;
            width: rw(140);
            height: rh(40);
            font-size:14px;
            /*font-family:MicrosoftYaHei;*/
            font-weight:400;
            /*background:#35B178;*/
            color: #fff;
            border: none;
            /*color:rgba(102,102,102,1);*/
            /*background:rgba(239,239,239,1);*/
            /*border:1px solid rgba(234,234,234,1);*/
            /*border-radius:3px;*/
        }
        .submit{
            width: rw(356);
            margin: 0 auto;
        }
        .el-divider--horizontal{
            margin: 0 0 24px 0;
        }
        .tip{
            width: rw(356);
            margin: 0 auto;
            display: flex;
            align-items: center;
            font-size:rh(14);
            font-family:MicrosoftYaHei;
            font-weight:400;
            margin-bottom: rh(19);
            span{
                color: rgba(102, 102, 102, 1);
            }
            i{
                color: rgba(47, 106, 204, 1);
                font-style: normal;
                cursor: pointer;
            }
        }
        .tip2{
            width: rw(356);
            margin: 0 auto;
            display: flex;
            align-items: center;
        }
        .el-checkbox{margin-right: rw(9);}
        .el-tabs__nav-wrap{
            display: flex;
            justify-content: center;
        }
        .el-tabs__nav-wrap::after{
            height: 0;
        }
        /*.el-tabs__nav{*/
        /*border-bottom: 2px solid #C2C0BE;*/
        /*}*/
        .msgCode{
            margin-top: -10px;
            margin-bottom: 10px;
            color: #DCDFE6;
            position: relative;
            margin-left: rw(322);
        }
    }
    .register{
        text-align: center;
        margin-top: rh(20);
        i{
            font-size:rh(14);
            font-family:MicrosoftYaHei;
            font-weight:400;
            color:#35B178;
            font-style: normal;
            cursor: pointer;
        }
    }
    #msg{
        height: 600px;
        overflow-y: scroll;
    }
</style>



// WEBPACK FOOTER //
// src/views/ForgetPwd.vue